import {RestService} from "./RestService";

export class ProductService extends RestService {
	constructor() {
		super(`api/v1/products`);
	}
	getProductCombos(productId) {
		return this.get(`${productId}/combo`);
	}
}